import { AUTHORIZATION } from "../../../constants/api/auth";
import { request } from "../api";
import { MESSAGE } from "../../../constants/api/message";
import { headers } from "../../../config/config";
import { StatusCodes } from "http-status-codes";

const { Authorization, Bearer } = AUTHORIZATION;
const { post } = request;

const initialRoute = "member";

export const viewSSNAddLog = async (_payload: any) => {
	try {
		const payload = _payload;
		const endpoint = `${initialRoute}/view-ssn-log`;
		const token = localStorage.getItem("@jwt");

		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			// console.log("Response data", response);
			const {
				status,
				data: { result }
			} = response;
			if (status === StatusCodes.OK) {
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};
